import { render } from "./DocumentTopBar.vue?vue&type=template&id=bd7cf984&scoped=true"
import script from "./DocumentTopBar.vue?vue&type=script&lang=js"
export * from "./DocumentTopBar.vue?vue&type=script&lang=js"

import "../../assets/scss/document_top_bar.scss?vue&type=style&index=0&id=bd7cf984&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd7cf984"]])

export default __exports__